<div class="modal-dialog-wrapper" appDialogSelectable>
  <mat-dialog-content appDialogKeyboardEnabled (cdkDragStarted)="dialogBoundryService.handleDragStart($event)" (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
    <div appDialogDragArea cdkDragHandle></div>
    <app-keyboard-shortcuts-modal (closed)="close()"></app-keyboard-shortcuts-modal>
  </mat-dialog-content>
</div>
